module.exports = __webpack_public_path__ + "6260d7b2ec3b97915ce881676a1f1fa9.png";